import { combineReducers } from 'redux';
import partsReducer from './partsReducer';

const reducer = combineReducers({
  parts: partsReducer,
})

export default reducer;
